import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@zocdoc/components/src/button';
import { FontFamily } from '@zocdoc/components/src/typography';
import { grey, navy } from '@zocdoc/branding/colors';
import { breakpoint } from '@zocdoc/components/src/grid/index';
import { IMAGES, MESSAGES } from '../constants';

class WellnessRecommendation extends PureComponent {
    static propTypes = {
        procedureId: PropTypes.string.isRequired,
    };

    render() {
        const {
            procedureId,
        } = this.props;

        const image = IMAGES[procedureId];
        const messages = MESSAGES[procedureId];

        const {
            buttonText,
            type,
        } = messages;

        return (
            <RecommendationWrapper
                data-test={`january-wellness-recommendation-${procedureId}`}
            >
                <RecommendationImage
                    data-test={`january-wellness-image-${procedureId}`}
                    image={image}
                />
                <RecommendationType
                    data-test={`january-wellness-recommendation-type-${procedureId}`}
                >
                    <FormattedMessage {...type} />
                </RecommendationType>
                {this.renderDescription()}
                <BookButton
                    data-test={`january-wellness-booking-button-${procedureId}`}
                    href={`/search?reason_visit=${procedureId}&pina_home_januarywellness=clickbookbutton_${procedureId}`}
                >
                    <FormattedMessage {...buttonText} />
                </BookButton>
            </RecommendationWrapper>
        );
    }

    renderDescription() {
        const {
            procedureId,
        } = this.props;

        const messages = MESSAGES[procedureId];
        const {
            description1,
            description2,
            referer,
            refererHover,
        } = messages;

        return description2 ? (
            <RecommendationDescription
                data-test={`january-wellness-recommendation-description-${procedureId}`}
            >
                <FormattedMessage {...description1} />
                <RecommendationHover
                    data-test={`january-wellness-recommendation-referer-hover-${procedureId}`}
                    title={refererHover.defaultMessage}
                >
                    <RecommendationReferer
                        data-test={`january-wellness-recommendation-referer-${procedureId}`}
                    >
                        <FormattedMessage {...referer} />
                    </RecommendationReferer>
                </RecommendationHover>
                <FormattedMessage {...description2} />
            </RecommendationDescription>
        ) : (
            <RecommendationDescription
                data-test={`january-wellness-recommendation-description-${procedureId}`}
            >
                <FormattedMessage {...description1} />
            </RecommendationDescription>
        );
    }
}

const RecommendationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center;
    margin-right: 45px;
    min-width: 280px;
    text-align: center;
    width: 280px;
    
    &:last-child {
        margin-right: 0;    
    }
    
    ${breakpoint('medium', { down: true })} {
        min-width: 250px;
        width: 250px;
    }
`;

const RecommendationImage = styled.div`
    background: url(${p => p.image}) center no-repeat;
    height: 98px;
    width: 100%;
`;

const RecommendationType = styled.div`
    color: ${navy};
    font: 15px/1.47 ${FontFamily.SharpSansBold};
    padding-top: 15px;
    width: 100%;
`;

const RecommendationReferer = styled.span`
    color: ${navy};
    font: 13px/1.69 ${FontFamily.SharpSansSemibold};
`;

const RecommendationHover = styled.abbr`
    color: ${navy};
    font: 15px ${FontFamily.SharpSansMedium};
`;

const RecommendationDescription = styled.div`
    color: ${grey};
    font: 13px/1.69 ${FontFamily.SharpSansMedium};
    padding-bottom: 15px;
    padding-top: 10px;
    width: 100%;
`;

const BookButton = styled(Button)`
    font: 15px ${FontFamily.SharpSansSemibold};
    margin-top: auto;
`;

export {
    WellnessRecommendation as default,
    WellnessRecommendation,
};
